import React, { useState } from "react";
import CommonHeading from "../common/CommonHeading";

import Gallery1 from "../../images/Gallery1.jpeg";
import Gallery2 from "../../images/Gallery2.jpeg";
import Gallery3 from "../../images/Gallery3.jpeg";
import Gallery4 from "../../images/Gallery4.jpeg";
import Gallery5 from "../../images/Gallery5.jpeg";
import Gallery6 from "../../images/Gallery6.jpeg";
import Gallery7 from "../../images/Gallery7.jpeg";
import Gallery8 from "../../images/Gallery8.jpeg";
import Gallery9 from "../../images/Gallery9.jpeg";
import Gallery10 from "../../images/Gallery10.jpeg";
import Gallery11 from "../../images/Gallery11.jpeg";
import Gallery12 from "../../images/Gallery12.jpeg";
import Gallery13 from "../../images/Gallery13.jpeg";
import Gallery14 from "../../images/Gallery14.jpeg";
import Gallery15 from "../../images/Gallery15.jpeg";
import Gallery16 from "../../images/Gallery16.jpeg";
import Gallery17 from "../../images/Gallery17.jpeg";
import Gallery18 from "../../images/Gallery18.jpeg";
import Gallery19 from "../../images/Gallery19.jpeg";

export default function Gallery() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const images = [
    Gallery1, Gallery2, Gallery3, Gallery4, Gallery5,
    Gallery6, Gallery7, Gallery8, Gallery9, Gallery10,
    Gallery11, Gallery12, Gallery13, Gallery14, Gallery15,
    Gallery16, Gallery17, Gallery18, Gallery19,
  ];

  const openModal = (index) => {
    setSelectedIndex(index);
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  const prevImage = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const nextImage = () => {
    setSelectedIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <>
      <style>{`
        .gallery-card{
          overflow:hidden;
          border-radius:10px;
          cursor:pointer;
          box-shadow:0 3px 10px rgba(0,0,0,.15);
          position:relative;
        }

        .gallery-image{
          width:100%;
          height:250px;
          object-fit:cover;
          transition:transform .5s ease;
        }

        .gallery-card:hover .gallery-image{
          transform:scale(1.15);
        }

        .gallery-card::after{
          content:'';
          position:absolute;
          inset:0;
          background:rgba(0,0,0,.15);
          opacity:0;
          transition:.3s;
        }

        .gallery-card:hover::after{
          opacity:1;
        }

        .zoom-icon{
          position:absolute;
          top:50%;
          left:50%;
          transform:translate(-50%,-50%);
          color:#fff;
          font-size:34px;
          opacity:0;
          transition:.3s;
          z-index:2;
        }

        .gallery-card:hover .zoom-icon{
          opacity:1;
        }

        .gallery-modal-img{
          max-height:80vh;
          width:100%;
          object-fit:contain;
        }

        .arrow-btn{
          position:absolute;
          top:50%;
          transform:translateY(-50%);
          background:rgba(0,0,0,0.7);
          border:none;
          color:#fff;
          font-size:30px;
          padding:10px 15px;
          cursor:pointer;
          z-index:10;
        }

        .arrow-left{
          left:10px;
        }

        .arrow-right{
          right:10px;
        }
      `}</style>

      <div className="container-xxl py-5">
        <div className="container">
          <CommonHeading
            heading="Gallery"
            title="Gallery"
            subtitle="Explore Our"
          />

          <div className="row">
            {images.map((img, index) => (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <div
                  className="gallery-card"
                  onClick={() => openModal(index)}
                >
                  <img
                    src={img}
                    alt={`Gallery ${index + 1}`}
                    className="gallery-image"
                  />

                  <div className="zoom-icon">
                    <i className="fa fa-search-plus"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedIndex !== null && (
        <>
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            onClick={closeModal}
          >
            <div
              className="modal-dialog modal-xl modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content position-relative">

                {/* Left Arrow */}
                <button className="arrow-btn arrow-left" onClick={prevImage}>
                  ❮
                </button>

                {/* Right Arrow */}
                <button className="arrow-btn arrow-right" onClick={nextImage}>
                  ❯
                </button>

                <div className="modal-header">
                  <h5 className="modal-title">Gallery Image</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>

                <div className="modal-body text-center">
                  <img
                    src={images[selectedIndex]}
                    alt="Gallery"
                    className="gallery-modal-img"
                  />
                </div>

              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}